// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__afEm-","badge":"CartButton_badge__V8C4B"};